<template>
    <Dialog v-model:visible="visibleLocal" modal :header="t('settings.users.roles_info.title')"
        :style="{ width: '500px' }">
        <div class="flex flex-col gap-4">
            <div class="flex flex-col gap-2">
                <p class="font-medium">{{ t('settings.users.roles_info.tenant_roles_title') }}</p>
                <div class="flex flex-col gap-3 pl-4">
                    <div class="flex flex-col gap-1">
                        <p class="text-sm font-medium">{{ t('settings.users.roles_info.tenant_admin_label') }}</p>
                        <p class="text-sm text-color-secondary">{{ t('settings.users.roles_info.tenant_admin_desc') }}</p>
                    </div>
                    <div class="flex flex-col gap-1">
                        <p class="text-sm font-medium">{{ t('settings.users.roles_info.tenant_member_label') }}</p>
                        <p class="text-sm text-color-secondary">{{ t('settings.users.roles_info.tenant_member_desc') }}</p>
                    </div>
                </div>
            </div>

            <div class="flex flex-col gap-2">
                <p class="font-medium">{{ t('settings.users.roles_info.resource_roles_title') }}</p>
                <div class="flex flex-col gap-3 pl-4">
                    <div class="flex flex-col gap-1">
                        <p class="text-sm font-medium">{{ t('settings.users.roles_info.resource_admin_label') }}</p>
                        <p class="text-sm text-color-secondary">{{ t('settings.users.roles_info.resource_admin_desc') }}</p>
                    </div>
                    <div class="flex flex-col gap-1">
                        <p class="text-sm font-medium">{{ t('settings.users.roles_info.resource_member_label') }}</p>
                        <p class="text-sm text-color-secondary">{{ t('settings.users.roles_info.resource_member_desc') }}</p>
                    </div>
                    <div class="flex flex-col gap-1">
                        <p class="text-sm font-medium">{{ t('settings.users.roles_info.resource_none_label') }}</p>
                        <p class="text-sm text-color-secondary">{{ t('settings.users.roles_info.resource_none_desc') }}</p>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <Button :label="t('shared.close')" severity="secondary" text @click="visibleLocal = false" />
        </template>
    </Dialog>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'

const props = defineProps<{ visible: boolean }>()
const emit = defineEmits<{
    (e: 'update:visible', value: boolean): void
}>()

const { t } = useI18n()

const visibleLocal = ref(props.visible)
watch(() => props.visible, (v) => (visibleLocal.value = v))
watch(visibleLocal, (v) => emit('update:visible', v))
</script>

<style scoped></style>

